const CheckinRequestModel = {
  idShort: '',
  tableEntrance: '',
};



export default CheckinRequestModel;
